/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Status_FailedInputs */

const cs_chat_status_failed = /** @type {(inputs: Chat_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslání selhalo`)
};

const en_chat_status_failed = /** @type {(inputs: Chat_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send`)
};

/**
* | output |
* | --- |
* | "Failed to send" |
*
* @param {Chat_Status_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_status_failed = /** @type {((inputs?: Chat_Status_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Status_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_status_failed(inputs)
	return cs_chat_status_failed(inputs)
});